import Benchmarking from './Benchmarking'

export default Benchmarking
